import React, { useEffect, useState } from "react";
import { Cpu, Activity } from "lucide-react";
import api from "@/lib/api";

const STATUS = {
  ACTIVE: "bg-emerald-500/15 text-emerald-500 border-emerald-500/30",
  RUNNING: "bg-blue-500/15 text-blue-500 border-blue-500/30",
  STANDBY: "bg-muted text-muted-foreground border-border",
};

export default function Agents() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/agents").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <div className="h-64 flex items-center justify-center"><div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" /></div>;

  return (
    <div className="space-y-6 animate-float-up">
      <div className="grid sm:grid-cols-3 gap-4">
        <div className="rounded-xl border border-border bg-card p-5"><p className="text-xs uppercase font-mono text-muted-foreground">Agentes</p><p className="font-heading text-2xl font-bold">{data.agents.length}</p></div>
        <div className="rounded-xl border border-border bg-card p-5"><p className="text-xs uppercase font-mono text-muted-foreground">Pesquisas realizadas</p><p className="font-heading text-2xl font-bold">{data.searches}</p></div>
        <div className="rounded-xl border border-border bg-card p-5"><p className="text-xs uppercase font-mono text-muted-foreground">Tarefas pendentes</p><p className="font-heading text-2xl font-bold">{data.tasks.length}</p></div>
      </div>
      <div className="grid sm:grid-cols-2 gap-4">
        {data.agents.map((a) => (
          <div key={a.key} className="rounded-xl border border-border bg-card p-5 flex items-start gap-4" data-testid={`agent-${a.key}`}>
            <div className="h-11 w-11 rounded-lg bg-primary/10 flex items-center justify-center shrink-0"><Cpu className="h-5 w-5 text-primary" /></div>
            <div className="flex-1">
              <div className="flex items-center justify-between gap-2">
                <h3 className="font-heading font-semibold">{a.name}</h3>
                <span className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-mono ${STATUS[a.status]}`}>
                  <Activity className="h-3 w-3" /> {a.status}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mt-1">{a.role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
